import React from 'react'
import './side-nav.css'
import { SideNavItems } from './SideNavItems'
import { SideNavState } from './context/SideNavState'
import '@mdsol/onex-design/themeProvider-v2.css'
import { ThemeProvider } from '@mdsol/onex-design'

/**
 * SideNav - Custom sidebar navigation with dynamic logic and custom CSS mimicking onex-design
 */

interface SideNavProps {
  setIsCollapsed?: (isCollapsed: boolean) => void
}

export function SideNav({ setIsCollapsed }: SideNavProps) {
  return (
    <ThemeProvider>
      <SideNavState>
        <SideNavItems setIsCollapsed={setIsCollapsed} />
      </SideNavState>
    </ThemeProvider>
  )
}

export default SideNav
